import { render, staticRenderFns } from "./ShopDashboard.vue?vue&type=template&id=51c45cc4&"
import script from "./ShopDashboard.vue?vue&type=script&lang=js&"
export * from "./ShopDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports